import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import Link from '@cred/react-link/analytics/Link'
import { ThemeContext } from '@cred/react-theme'

import Tooltip from 'components/tooltip'
import WidgetContext from 'components/widget-context'

import { getReviewUrl } from '../utils'
import styles from '../LenderCard.module.scss'
import { BELOW_LOGO_TEXT, LOGOS, RATING_TOOLTIP_BODY, RATING_LINK } from './config'

const LenderCardTop = ({ lenderSlug, lenderName, vertical, rating }) => {
  const theme = useContext(ThemeContext)
  const widgetContext = useContext(WidgetContext)
  const hideTooltip = [true, 'true'].includes(widgetContext?.options?.ui?.hideTooltip)

  const reviewLink = getReviewUrl(lenderSlug, theme)

  const onReviewLinkClick = () => {
    window.open(reviewLink, '_blank')
  }

  return (
    <div className={styles.flex}>
      <div className={styles.left}>
        <img src={LOGOS[lenderSlug]} alt={`${lenderName} logo`} className={styles.logo} />
      </div>
      <div className={styles.right}>
        <p className={styles.rating}>
          <i className="cred-icon icon-star mr-8 primary500" />
          <span>{(rating || 5.0).toFixed(1)}</span>{' '}
          <span className="disclaimer neutral500">/5</span>
        </p>
        {reviewLink ? (
          <Link onClick={onReviewLinkClick} className="disclaimer fs-12-wide secondary500">
            {RATING_LINK[theme]}
          </Link>
        ) : (
          <span className="disclaimer fs-12-wide secondary500">{RATING_LINK[theme]}</span>
        )}
        {!hideTooltip && (
          <Tooltip
            triggerContent={<i className="cred-icon icon-help-outline neutral400" />}
            triggerClassName="disclaimer ml-4"
            contentClassName="disclaimer align-left"
            analyticsOptions={{ contentSubject: RATING_LINK[theme] }}
          >
            {RATING_TOOLTIP_BODY[theme]}
          </Tooltip>
        )}
      </div>
      <p className={`${styles.bottomText} below-logo-text bold bodySmall`}>
        {lenderName} {BELOW_LOGO_TEXT[vertical]}
      </p>
    </div>
  )
}

LenderCardTop.propTypes = {
  lenderSlug: PropTypes.string.isRequired,
  lenderName: PropTypes.string.isRequired,
  vertical: PropTypes.string.isRequired,
  rating: PropTypes.number,
}

export default LenderCardTop
